<template>
  <div class="content main-container">
    <Tabs v-model="activeTab" :animated="false">
      <TabPane label="基本法佣金项" name="basic">
        <basicTab />
      </TabPane>
      <TabPane label="周边收支" name="surrounding">
        <surroundingTab :ifaList="ifaList" />
      </TabPane>
      <TabPane label="佣金调整" name="adjust">
        <adjustTab :ifaList="ifaList" />
      </TabPane>
    </Tabs>
  </div>
</template>

<script>
import basicTab from './components/basicTab';
import surroundingTab from './components/surroundingTab';
import adjustTab from './components/adjustTab';

export default {
  name: 'SettlementManage',
  components: {
    basicTab,
    surroundingTab,
    adjustTab
  },
  data() {
    return {
      activeTab: 'basic',
      ifaList: []
    };
  },
  mounted() {
    this.getIfaList();
  },
  methods: {
    getIfaList() {
      this.$http({
        url: '/buz/userBase/list',
        type: 'POST',
        data: { selectSub: 1 }
      }).then(res => {
        this.ifaList = res.data.filter(i => i.ifaType != 2);
      });
    }
  }
};
</script>
